import { Component } from '@angular/core';

@Component({
  selector: 'app-daily-sales-retunr-detail',
  standalone: false,
  
  templateUrl: './daily-sales-retunr-detail.component.html',
  styles: ``
})
export class DailySalesRetunrDetailComponent {

}
